export default __webpack_public_path__ + "static/zaru_collages_v6-9-d66f670d0cf0f2ab6e8accbe556d64da.png";